var OverlayFaqController = function($) {
	var _o = {},

		_LoadContent = function($cc, o) {
			_o = o;
			$.get( "/_overlays/faqs", function( data ) {
				$cc.html( data );
				_InitFAQs();
				if (_o.onInit) {
					_o.onInit();
				}
			});
		},

		_InitFAQs = function() {
			// Setup the navigation
			$fn = $('.module-faqs-navigation__item');
			$fn.click(_OnFAQNavClick);

			// Setup the acordion functionality
			$ft = $('.module-faqs-list__item--title');
			$ft.click(_OnFAQTitleClick);

			var $t = $fn.filter(function(i, el) {
				return $(el).prop('hash') === _o.trigger;
			});
			if ($t.length) {
				$fn.eq($t.index()).click();
			} else {
				$fn.eq(0).addClass('active');
			}
		},

			_OnFAQNavClick = function(e) {
				e.preventDefault();
				var $$ = $(e.currentTarget),
					h = $$.prop("hash"),
					$f = $(h);

				$fn.removeClass('active');
				$$.addClass('active');
				
				$('.module-faqs-list__container').hide();
				$f.show();
			},

			_OnFAQTitleClick = function(e) {
				e.preventDefault();
				var $$ = $(e.currentTarget),
					$d = $$.next();

				if ($$.hasClass(_o.openClass)) {
					$d.slideUp();
					$$.removeClass(_o.openClass);
				} else {
					$d.slideDown();
					$$.addClass(_o.openClass);
				}
			};

	return {
		init: function($cc, o) {
			_LoadContent($cc, o);
		}
	};
};

